import {Column, HeaderProps} from 'react-table'
import {PropsWithChildren} from 'react'
import {CustomHeader} from '../../utils/components/table-content/CustomHeader'
import {IRouteSenderDetails} from './_model'
import {KTIcon} from '../../../_metronic/helpers'
import {dateFormat} from '../../utils/helperFunction/_helper'

const routeSenderDetailsColumn = (
  handleSelect: (id: number) => void
): ReadonlyArray<Column<IRouteSenderDetails>> => {
  const onEdit = (id: number) => handleSelect(id)
  return [
    {
      Header: (props: PropsWithChildren<HeaderProps<IRouteSenderDetails>>) => (
        <CustomHeader tableProps={props} title='source name' className='min-w-100px' />
      ),
      id: 'sourceRouteName',
      accessor: 'sourceRouteName',
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<IRouteSenderDetails>>) => (
        <CustomHeader tableProps={props} title='source sender' className='min-w-100px' />
      ),
      id: 'sourceSender',
      accessor: 'sourceSender',
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<IRouteSenderDetails>>) => (
        <CustomHeader tableProps={props} title='destination name' className='min-w-100px' />
      ),
      id: 'destinationRouteName',
      accessor: 'destinationRouteName',
    },

    {
      Header: (props: PropsWithChildren<HeaderProps<IRouteSenderDetails>>) => (
        <CustomHeader tableProps={props} title='destination sender' className='min-w-100px' />
      ),
      id: 'destinationSender',
      accessor: 'destinationSender',
    },
    // {
    //   Header: (props: PropsWithChildren<HeaderProps<IRouteSenderDetails>>) => (
    //     <CustomHeader tableProps={props} title='destination Route' className='min-w-100px' />
    //   ),
    //   id: 'destRoute',
    //   accessor: 'destRoute',
    // },

    {
      Header: (props: PropsWithChildren<HeaderProps<IRouteSenderDetails>>) => (
        <CustomHeader tableProps={props} title='status' className='min-w-100px' />
      ),
      id: 'status',
      Cell: ({...props}) => (
        <div className=''>
          <span
            className={`badge ${
              props.data[props.row.index].status === 1
                ? 'badge-light-primary'
                : 'badge-light-warning'
            }`}
          >
            {props.data[props.row.index].status === 1 ? 'Active' : 'Inactive'}
          </span>
        </div>
      ),
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<IRouteSenderDetails>>) => (
        <CustomHeader tableProps={props} title='insert date' className='min-w-100px' />
      ),
      id: 'insDate',
      accessor: 'insDate',
      Cell: ({...props}) => <span>{dateFormat(props.data[props.row.index].insDate, true)}</span>,
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<IRouteSenderDetails>>) => (
        <CustomHeader tableProps={props} title='lastUpdate' className='min-w-100px' />
      ),
      id: 'lastUpdate',
      accessor: 'lastUpdate',
      Cell: ({...props}) => <span>{dateFormat(props.data[props.row.index].lastUpdate, true)}</span>,
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<IRouteSenderDetails>>) => (
        <CustomHeader tableProps={props} title='Action' className='min-w-100px text-end' />
      ),
      id: 'action',
      Cell: ({...props}) => (
        <div className='text-end'>
          <a
            href='#'
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 mb-1'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_2'
            onClick={() => onEdit(props.data[props.row.index].altId)}
          >
            <KTIcon iconName='pencil' className='fs-3' />
          </a>
        </div>
      ),
    },
  ]
}

export default routeSenderDetailsColumn
